// extracted by mini-css-extract-plugin
export default {"polaroid":"OccasionCard_polaroid__1uif9","Button":"OccasionCard_Button__yxxOu","description":"OccasionCard_description__DIPfq","Title":"OccasionCard_Title__bPMNR"};